module.exports = __webpack_public_path__ + "img/logo_vertical_white.23ab07ad.png";